import type { PreparationContent } from "./preparation-studio.js";

// A preparation draft is intentionally allowed to be incomplete.  The Core
// distinguishes an omitted value from an invalid required-looking empty
// string, while final approval still performs the complete quality checks.
// Keeping this projection explicit prevents a blank field in the progressive
// form from blocking a save or a switch to the conversational path.
export function preparationDraftPayload(content: PreparationContent): Partial<PreparationContent> {
  const { companyName, businessArea, attendanceRules, ...rest } = content;
  return {
    ...rest,
    ...(companyName.trim() ? { companyName } : {}),
    ...(businessArea.trim() ? { businessArea } : {}),
    ...(attendanceRules.trim() ? { attendanceRules } : {}),
  };
}
